// extracted by mini-css-extract-plugin
module.exports = {"Rating":"Rating_Rating__1RBxA","RatingSmall":"Rating_RatingSmall__Ji1WW","RatingSmaller":"Rating_RatingSmaller__lyEvZ"};